module.exports = __webpack_public_path__ + "static/media/cellphone.f455671a.svg";